import {Controller} from "stimulus"

export default class extends Controller {
    static targets = [
        "destinationSelect",
        "roomsSelect",
        "minPriceSlider",
        "maxPriceSlider",
        "item",
        "count"
    ]

    connect() {
        console.log("✅ Filterable controller connected")
        console.log("📊 Total items:", this.itemTargets.length)
        this.initPriceRange()
        this.updateCount()
    }

    // Inicializar el rango de precios
    initPriceRange() {
        if (!this.hasMinPriceSliderTarget || !this.hasMaxPriceSliderTarget) return

        const minSlider = this.minPriceSliderTarget
        const maxSlider = this.maxPriceSliderTarget
        const minPrice = parseFloat(minSlider.min)
        const maxPrice = parseFloat(maxSlider.max)

        console.log(`💰 Rango de precios: $${minPrice} - $${maxPrice}`)

        // Actualizar display inicial
        this.updatePriceDisplay()

        // Validar que los valores estén dentro del rango
        minSlider.addEventListener('input', () => {
            const minValue = parseFloat(minSlider.value)
            const maxValue = parseFloat(maxSlider.value)

            if (minValue > maxValue) {
                minSlider.value = maxValue
            }
            if (minValue < minPrice) {
                minSlider.value = minPrice
            }

            this.updatePriceDisplay()
        })

        maxSlider.addEventListener('input', () => {
            const minValue = parseFloat(minSlider.value)
            const maxValue = parseFloat(maxSlider.value)

            if (maxValue < minValue) {
                maxSlider.value = minValue
            }
            if (maxValue > maxPrice) {
                maxSlider.value = maxPrice
            }

            this.updatePriceDisplay()
        })
    }

    // Actualizar display del rango de precios
    updatePriceDisplay() {
        const minValue = parseFloat(this.minPriceSliderTarget.value)
        const maxValue = parseFloat(this.maxPriceSliderTarget.value)
        const minPrice = parseFloat(this.minPriceSliderTarget.min)
        const maxPrice = parseFloat(this.maxPriceSliderTarget.max)

        // Actualizar textos
        document.getElementById('min-price-value').textContent = `$${minValue}`
        document.getElementById('max-price-value').textContent = `$${maxValue}`

        // Actualizar área visual del rango (si existe el CSS)
        this.updateRangeVisual(minValue, maxValue, minPrice, maxPrice)
    }

    // Actualizar visualización del rango (opcional)
    updateRangeVisual(minValue, maxValue, minPrice, maxPrice) {
        const rangeInputs = document.querySelector('.range-inputs')
        if (rangeInputs && rangeInputs.style.setProperty) {
            // Calcular porcentajes
            const totalRange = maxPrice - minPrice
            const minPercent = totalRange > 0 ? ((minValue - minPrice) / totalRange) * 100 : 0
            const maxPercent = totalRange > 0 ? ((maxValue - minPrice) / totalRange) * 100 : 100

            rangeInputs.style.setProperty('--range-min', `${minPercent}%`)
            rangeInputs.style.setProperty('--range-max', `${maxPercent}%`)
        }
    }

    // Aplicar todos los filtros
    applyFilters() {
        const destination = this.destinationSelectTarget.value
        const rooms = this.roomsSelectTarget.value
        const minPrice = parseFloat(this.minPriceSliderTarget.value)
        const maxPrice = parseFloat(this.maxPriceSliderTarget.value)

        console.log(`🎯 Filtros: Destino=${destination}, Habitaciones=${rooms}, Precio=$${minPrice}-$${maxPrice}`)

        this.itemTargets.forEach(item => {
            const show = this.passesFilters(item, destination, rooms, minPrice, maxPrice)
            item.style.display = show ? "" : "none"
        })

        this.updateCount()
    }

    // Verificar si un item pasa todos los filtros
    passesFilters(item, destination, rooms, minPrice, maxPrice) {
        // 1. Filtrar por destino
        if (destination && item.dataset.destination !== destination) {
            return false
        }

        // 2. Filtrar por habitaciones
        if (rooms && !this.passesRoomFilter(item, rooms)) {
            return false
        }

        // 3. Filtrar por precio
        if (!this.passesPriceFilter(item, minPrice, maxPrice)) {
            return false
        }

        return true
    }

    // Filtrar por habitaciones
    passesRoomFilter(item, roomsFilter) {
        const itemRooms = parseInt(item.dataset.rooms) || 0
        const filterRooms = parseInt(roomsFilter)

        /*if (roomsFilter === "4") {
            // 4+ habitaciones
            return itemRooms >= 4
        } else {
            // Filtro exacto*/
        return itemRooms === filterRooms
        /*}*/
    }

    // Filtrar por precio
    passesPriceFilter(item, minPrice, maxPrice) {
        const itemPrice = parseFloat(item.dataset.price) || 0
        return itemPrice >= minPrice && itemPrice <= maxPrice
    }

    // Resetear todos los filtros
    resetFilters() {
        console.log("🔄 Reseteando filtros")

        // Resetear selects
        this.destinationSelectTarget.value = ""
        this.roomsSelectTarget.value = ""

        // Resetear sliders de precio a los valores min/max originales
        const minPrice = parseFloat(this.minPriceSliderTarget.min)
        const maxPrice = parseFloat(this.maxPriceSliderTarget.max)

        this.minPriceSliderTarget.value = minPrice
        this.maxPriceSliderTarget.value = maxPrice

        // Actualizar display
        this.updatePriceDisplay()

        // Mostrar todos los items
        this.itemTargets.forEach(item => {
            item.style.display = ""
        })

        this.updateCount()
    }

    // Actualizar contador
    updateCount() {
        const visible = Array.from(this.itemTargets).filter(item =>
            item.style.display !== "none"
        ).length

        const total = this.itemTargets.length

        console.log(`📈 Visible: ${visible} / Total: ${total}`)

        if (this.countTarget) {
            // this.countTarget.textContent = `Mostrando ${visible} casas disponibles`
            this.countTarget.textContent = I18n.t('home.page.show_x_homes', {count: visible})
        }
    }
}